import bugsnag from "@bugsnag/js";
import axios from "axios";

const client = bugsnag({
  apiKey: "c3afa4571ff87d028ae122fea9914a86",
  notifyReleaseStages: ["production", "staging"],
  releaseStage: process.env.NODE_ENV
});

try {
  axios.get("/version.json").then(function({ data }) {
    client.setOptions({
      appVersion: data ? data["Build number"] + " - " + data["Commit id"] : null
    });
  });
} catch (error) {}

export default client;



// WEBPACK FOOTER //
// ./resources/js/plugins/bugsnag.js